// React imports
import { useContext } from "react";
import { AuthContext, AuthContextType } from "../../context/AuthProvider";
import { useQuery } from "@tanstack/react-query";
import { ParsedToken } from "firebase/auth";

const useClaims = () => {
	const { user } = useContext(AuthContext) as AuthContextType;
	const { data: userClaims } = useQuery({
		queryKey: ["user", user?.uid, "claims"],
		queryFn: async (): Promise<ParsedToken> => {
			if (user?.uid) {
				const { claims } = await user.getIdTokenResult(true);
				return claims;
			}
			return {};
		}
	});

	return userClaims;
};

export default useClaims;
